<script setup lang="ts">
  const selectionPolygonsStore = useSelectionPolygonsStores()
  const { updatePolygonDialog, currentItem, writeLoading } = storeToRefs(selectionPolygonsStore)
  const localZoneName = ref()
  const clickUpdatePolygon = async () => {
    if (currentItem.value && currentItem.value.properties) {
      currentItem.value.properties.zone_name = localZoneName.value
    }
    await selectionPolygonsStore.update(currentItem?.value)
    selectionPolygonsStore.toggleUpdatePolygonDialog()
  }

  watch(currentItem, (newItem) => {
    if (newItem && newItem.properties) {
      localZoneName.value = newItem.properties.zone_name
    }
  })
</script>
<template>
  <v-dialog width="400" v-model="updatePolygonDialog">
    <v-card>
      <v-card-title>Update Polygon</v-card-title>
      <v-card-text>
        <v-form>
          <v-text-field color="primary" label="Polygon Name" v-model="localZoneName"></v-text-field>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="primary"
          variant="text"
          @click="selectionPolygonsStore.toggleUpdatePolygonDialog()"
          >Cancel</v-btn
        >
        <v-btn :loading="writeLoading" color="primary" variant="text" @click="clickUpdatePolygon">
          Save
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<style scoped></style>
